import "./Agreementpage.scss";

const AgreementPage = () => {
    return (
        <div style={{marginTop: "90px", display: "flex", flexDirection: "column", textAlign: "center"}} className="container agreement">
            <h3 style={{margin: "auto", padding: "20px 0"}}>ЗАГАЛЬНІ ПОЛОЖЕННЯ</h3>
            <div style={{marginBottom: "10px"}}>
                Askold не пов'язаний і не схвалений Bohemia Interactive або будь-яким іншим правовласником.
            </div>
            <div style={{marginBottom: "10px"}}>
                Усі використовувані торгові марки належать їхнім власникам.
            </div>
            <div style={{marginBottom: "10px"}}>
                Цей документ (далі – Правила, Угода) є офіційною публічною офертою (далі – «Виконавець», «Оферент»), адресованою невизначеному колу осіб, та містить всі суттєві умови для надання послуг та купівлі-продажу товарів, запропонованих Оферентом та представлених на сайті https://askold-dayz.com.ua.
            </div>
            <div style={{marginBottom: "10px"}}>
                Сторони визнають погодженим, що беззаперечним акцептом цієї Оферти є факт оплати Замовником послуг, запропонованих Виконавцем. Перелік та зміст товарів і послуг, які Замовник набуває у Виконавця, формується на сайті https://askold-dayz.com.ua.
            </div>
            <div style={{marginBottom: "10px"}}>
                Особи, молодші 18 років, не мають права приймати умови цієї Угоди.
            </div>
            <div style={{marginBottom: "10px"}}>
                Сторони визнають погодженим, що акти прийому-передачі товарів та послуг між сторонами не складаються.
            </div>
            <div style={{marginBottom: "10px"}}>
                У разі незгоди з цими Правилами Користувач зобов'язується не приймати умови цієї оферти та/або відмовитися від виконання Угоди.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>ПРЕДМЕТ УГОДИ</h3>

            <div style={{marginBottom: "10px"}}>
                Виконавець зобов'язується надати Замовнику за винагороду послуги та/або товари, обрані Замовником, у вигляді та на умовах, представлених на сайті Виконавця https://askold-dayz.com.ua (далі – Сайт), а Замовник зобов'язується прийняти ці послуги та/або товари та оплатити їх у порядку, зазначеному на Сайті.
            </div>
            <div style={{marginBottom: "10px"}}>
                Права та обов'язки за угодами, укладеними Виконавцем відповідно до цієї Угоди, виникають безпосередньо у Замовника.
            </div>
            <div style={{marginBottom: "10px"}}>
                Ця Угода вважається укладеною з дати акцепту цієї Оферти.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>ПРАВА ТА ОБОВ'ЯЗКИ ВИКОНАВЦЯ</h3>

            <div style={{marginBottom: "10px"}}>
                Виконавець зобов'язаний:
            </div>
            <div style={{marginBottom: "10px"}}>
                Надати послуги та/або товари належним чином і в погоджені Сторонами терміни.
            </div>
            <div style={{marginBottom: "10px"}}>
                Інформувати Замовника про хід надання послуг за запитом.
            </div>
            <div style={{marginBottom: "10px"}}>
                Виконавець має право:
            </div>
            <div style={{marginBottom: "10px"}}>
                Отримувати своєчасну та повну оплату товарів і/або послуг.
            </div>
            <div style={{marginBottom: "10px"}}>
                Отримувати від Замовника повну та достовірну інформацію, необхідну для надання послуг.
            </div>
            <div style={{marginBottom: "10px"}}>
                Залучати третіх осіб – Співвиконавців – для надання послуг.
            </div>
            <div style={{marginBottom: "10px"}}>
                Призупинити доступ Користувача до товарів і/або послуг, якщо його дії або бездіяльність можуть завдати шкоди Сайту або Виконавцю, або порушують інші правила Виконавця.
            </div>
            <div style={{marginBottom: "10px"}}>
                Замовник зобов'язується:
            </div>
            <div style={{marginBottom: "10px"}}>
                Своєчасно та в повному обсязі оплачувати послуги Виконавця.
            </div>
            <div style={{marginBottom: "10px"}}>
                Надати Виконавцю інформацію, необхідну для надання послуг.
            </div>
            <div style={{marginBottom: "10px"}}>
                Сприяти успішному наданню послуг.
            </div>
            <div style={{marginBottom: "10px"}}>
                Замовник має право:
            </div>
            <div style={{marginBottom: "10px"}}>
                Отримати послуги в порядку і на умовах, зазначених у цій Угоді.
            </div>
            <div style={{marginBottom: "10px"}}>
                Запитувати інформацію про хід надання послуг.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>ТЕРМІН ДІЇ УГОДИ</h3>

            <div style={{marginBottom: "10px"}}>
                Ця Угода вважається укладеною з моменту акцепту Оферти (з дати оплати Замовником товарів і/або послуг Виконавця) і діє до повного виконання сторонами своїх зобов'язань.
            </div>
            <div style={{marginBottom: "10px"}}>
                Виконавець має право в односторонньому порядку відмовитися від виконання Угоди, якщо Замовник не надав необхідних документів для надання послуг.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>ВІДПОВІДАЛЬНІСТЬ СТОРІН</h3>

            <div style={{marginBottom: "10px"}}>
                Виконавець не несе відповідальності за затримку у виконанні зобов'язань, викликану діями Замовника або зміною законодавства.
            </div>
            <div style={{marginBottom: "10px"}}>
                Замовник втрачає право заперечувати оплату після акцепту Угоди.
            </div>
            <h3 style={{margin: "auto", padding: "20px 0"}}>ЗАКЛЮЧНІ ПОЛОЖЕННЯ</h3>

            <div style={{marginBottom: "10px"}}>
                Сторони визнають юридичну силу за перепискою через e-mail та месенджери.
            </div>
            <div style={{marginBottom: "10px"}}>
                Товари, придбані за Угодою, поверненню не підлягають.
            </div>
        </div>
    );
};

export default AgreementPage;
